import React from "react";
import { Form, Modal, Button, Row, Col } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import { callApi, validateToken } from "../../lib/utils";
import TextField from "../GenericComponents/TextField";
import CustomLoader from "../GenericComponents/CustomLoader";
//import styles from "../../../public/";
import styles from "./style";

const initialState = { oldPassword: "", newPassword: "", confirmPassword: "" };

class ChangePasswordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      failureMessage: "",
      successMessage: "",
      oldPasswordInputType: "password",
      oldPasswordToggleIcon: "fa fa-eye",
      oldPasswordToggleTitle: "show password",
      newPasswordInputType: "password",
      newPasswordToggleIcon: "fa fa-eye",
      newPasswordToggleTitle: "show password",
      confirmPasswordInputType: "password",
      confirmPasswordToggleIcon: "fa fa-eye",
      confirmPasswordToggleTitle: "show password",
    };
  }

  handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;

    this.setState({
      [fieldName]: fieldValue,
    });
  };

  handleClose = () => {
    this.setState(
      {
        ...initialState,
        failureMessage: "",
        successMessage: "",
      },
      () => {
        this.props.close();
      }
    );
  };

  submit = () => {
    let oldPassword = this.state.oldPassword;
    let newPassword = this.state.newPassword;
    let newPasswordConfirm = this.state.confirmPassword;
    let hasUpper = /[A-Z]+/.test(newPassword),
      hasLower = /[a-z]+/.test(newPassword),
      hasNumber = /[\d]+/.test(newPassword),
      hasSpecial = /[$@$!%*#?&]+/.test(newPassword),
      hasCorrectSym = /^[A-Za-z\d$@$!%*#?&.,]{8,}$/.test(newPassword);
    let i = 0;
    if (hasUpper) i++;
    if (hasLower) i++;
    if (hasNumber) i++;
    if (hasSpecial) i++;
    if (oldPassword.length === 0) {
      this.setState({
        ...initialState,
        failureMessage: "Old Password cannot be blank",
      });
    } else if (newPassword.length === 0) {
      this.setState({
        ...initialState,
        failureMessage: "New Password cannot be blank",
      });
    } else if (oldPassword === newPassword) {
      this.setState({
        ...initialState,
        failureMessage: "New Password cannot be same as your old password",
      });
    } else if (newPassword.length < 8) {
      this.setState({
        ...initialState,
        failureMessage: "New Password must contain at least 8 characters",
      });
    } else if (i < 4 || !hasCorrectSym) {
      this.setState({
        ...initialState,
        failureMessage:
          "Passwords must contain at least 1 uppercase, 1 lowercase, 1 number and a special character.",
      });
    } else if (newPassword !== newPasswordConfirm) {
      this.setState({
        ...initialState,
        failureMessage: "Enter the same Password as above",
      });
    } else {
      validateToken((err) => {
        if (err) {
          window.location = "/logout";
        }
        let params = {
          oldPassword: oldPassword,
          newPassword: newPassword,
          confirmPassword: newPasswordConfirm,
        };
        this.setState({
          loading: true,
        });
        callApi(`/api/patient/web/change-password`, params, "POST")
          .then((response) => {
            //console.log("response...", response);
            if (response.status === 200) {
              this.setState(
                {
                  ...initialState,
                  successMessage: "Password Changed Successfully",
                  failureMessage: "",
                  loading: false,
                },
                () => {
                  this.props.handleSuccessModal(this.state.successMessage);
                }
              );
            } else {
              this.setState({
                ...initialState,
                failureMessage: response.data.message,
                loading: false,
              });
            }
          })
          .catch((err) => {
            console.log("err: ", err);
            this.setState({
              ...initialState,
              failureMessage: err.message ? err.message : "something went wrong!",
              loading: false,
            });
          });
      });
    }
  };

  handlePassword = (val) => {
    switch (val) {
      case "oldPassword":
        if (this.state.oldPasswordInputType === "password") {
          this.setState({
            oldPasswordInputType: "text",
            oldPasswordToggleIcon: "fa fa-eye-slash",
            oldPasswordToggleTitle: "hide password",
          });
        } else {
          this.setState({
            oldPasswordInputType: "password",
            oldPasswordToggleIcon: "fa fa-eye",
            oldPasswordToggleTitle: "show password",
          });
        }
        break;
      case "newPassword":
        if (this.state.newPasswordInputType === "password") {
          this.setState({
            newPasswordInputType: "text",
            newPasswordToggleIcon: "fa fa-eye-slash",
            newPasswordToggleTitle: "hide password",
          });
        } else {
          this.setState({
            newPasswordInputType: "password",
            newPasswordToggleIcon: "fa fa-eye",
            newPasswordToggleTitle: "show password",
          });
        }
        break;
      case "confirmPassword":
        if (this.state.confirmPasswordInputType === "password") {
          this.setState({
            confirmPasswordInputType: "text",
            confirmPasswordToggleIcon: "fa fa-eye-slash",
            confirmPasswordToggleTitle: "hide password",
          });
        } else {
          this.setState({
            confirmPasswordInputType: "password",
            confirmPasswordToggleIcon: "fa fa-eye",
            confirmPasswordToggleTitle: "show password",
          });
        }
        break;
    }
  };

  render() {
    const { show, title } = this.props;

    return (
      <div>
        <CustomLoader loading={this.state.loading} />
        <Modal
          size="md"
          show={show}
          onHide={this.handleClose}
          centered={true}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className={css(styles.headerStyle)}>
            <Modal.Title>
              <div className={css(styles.title)}>{title}</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {this.state.failureMessage && (
                <div
                  style={{
                    backgroundColor: "white",
                    color: "red",
                    textAlign: "center",
                  }}
                >
                  {this.state.failureMessage}
                </div>
              )}
              {/* {this.state.successMessage && (
                <div
                  style={{
                    backgroundColor: "white",
                    color: "green",
                    textAlign: "center",
                  }}
                >
                  {this.state.successMessage}
                </div>
              )} */}
              <p className="pStyle"></p>
              <Form className="form-horizontal" autoComplete="off">
                <Form.Group style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "100%" }}>
                    <TextField
                      type={this.state.oldPasswordInputType}
                      placeholder={"Old Password"}
                      name={"oldPassword"}
                      value={this.state.oldPassword}
                      action={this.handleChange}
                      className="form-control inputstyle"
                    //required={true}
                    />
                  </div>
                  <div>
                    <span
                      className={this.state.oldPasswordToggleIcon}
                      style={{ cursor: "pointer" }}
                      title={this.state.oldPasswordToggleTitle}
                      onClick={() => this.handlePassword("oldPassword")}
                    />
                  </div>
                </Form.Group>{" "}
                <br />
                <Form.Group style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "100%" }}>
                    <TextField
                      type={this.state.newPasswordInputType}
                      placeholder={"New Password"}
                      name={"newPassword"}
                      value={this.state.newPassword}
                      action={this.handleChange}
                      className="form-control inputstyle"
                    //required={true}
                    />
                  </div>
                  <div>
                    <span
                      className={this.state.newPasswordToggleIcon}
                      style={{ cursor: "pointer" }}
                      title={this.state.newPasswordToggleTitle}
                      onClick={() => this.handlePassword("newPassword")}
                    />
                  </div>
                </Form.Group>
                <br />
                <Form.Group style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "100%" }}>
                    <TextField
                      type={this.state.confirmPasswordInputType}
                      placeholder={"Confirm Password"}
                      name={"confirmPassword"}
                      value={this.state.confirmPassword}
                      action={this.handleChange}
                      className="form-control inputstyle"
                    //required={true}
                    />
                  </div>
                  <div>
                    <span
                      className={this.state.confirmPasswordToggleIcon}
                      style={{ cursor: "pointer" }}
                      title={this.state.confirmPasswordToggleTitle}
                      onClick={() => this.handlePassword("confirmPassword")}
                    />
                  </div>
                </Form.Group>
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer className={css(styles.footerStyle)}>
            <Button variant="primary" onClick={() => this.submit()}>
              Change Password
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ChangePasswordModal;

